// src/pages/Home.js
import React, { useEffect} from 'react';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { Box } from '@mui/material';

const Home = () => {
  const token = useSelector((state) => state.auth.token);
  const Username = useSelector((state) => state.auth.name);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get('/api/home-data', {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });
      } catch (error) {
        console.error('Error fetching data:', error);
      }
    };

    if (token) {
      fetchData();
    }
  }, [token]);

  return (
   <Box p={2}>Welcome to Georgia Probate Law Group, {Username}!</Box>
  )
};

export default Home;
